import { VectorSquare } from '@emotion-icons/fa-solid/VectorSquare'
import { EmotionIcon } from '@emotion-icons/emotion-icon'
import { UserListModalListItemType } from 'src/components/user-lists-modal'
import { MapSigns } from '@emotion-icons/fa-solid/MapSigns'
import { MapMarkerAlt } from '@emotion-icons/fa-solid/MapMarkerAlt'
import { ListUl } from '@emotion-icons/fa-solid/ListUl'
import { Briefcase } from '@emotion-icons/fa-solid/Briefcase'

export const USER_LIST_ITEM_ICONS: Record<UserListModalListItemType, EmotionIcon> = {
  list: ListUl,
  location: MapMarkerAlt,
  place: MapSigns,
  'custom-area': VectorSquare,
  parcel: VectorSquare /** TODO(angel): add support to add parcels to user lists on web */,
  owner: Briefcase,
}
